import { Directive, ElementRef, Input, Renderer2, HostListener, OnInit, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Directive({
    selector: '[appTooltip]'
})
export class TooltipDirective implements OnInit, OnDestroy {
    @Input() contextData: any;
    @Input() tooltipData: string;
    tooltipElement: HTMLElement;

    routerSubscription: Subscription;

    constructor(private el: ElementRef, private renderer: Renderer2, private router: Router) { }

    ngOnInit(): void {
        this.routerSubscription = this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.destroyTooltip();
            }
        });
    }

    ngOnDestroy(): void {
        // Si se destruye el componente, la suscripción ya no vive y no se ejecutaría el método destroyTooltip()
        this.destroyTooltip();
        this.routerSubscription?.unsubscribe();
    }

    @HostListener('mouseenter') onMouseEnter() {
        this.createTooltip();
    }

    @HostListener('mouseleave') onMouseLeave() {
        this.destroyTooltip();
    }

    createTooltip() {
        // Por si se dispara mouseenter varias veces
        if (this.tooltipElement) return;

        this.tooltipElement = this.renderer.createElement('img');
        if(this.tooltipData)
            this.renderer.setAttribute(this.tooltipElement, 'src', this.tooltipData);
        this.renderer.setAttribute(this.tooltipElement, 'alt', 'Previsualización no disponible');
        this.renderer.addClass(this.tooltipElement, 'tooltip-image');
        this.renderer.appendChild(document.body, this.tooltipElement);

        if(this.tooltipElement)
            this.setPosition();
    }

    setPosition() {
        const hostPos: DOMRect = this.el.nativeElement.getBoundingClientRect();
        const tooltipPos: DOMRect = this.tooltipElement.getBoundingClientRect();

        // Para que salga en mitad de la columna
        let left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
        let top = hostPos.top + hostPos.height; // Mostrar abajo

        // Comprobar si el elemento host está en la mitad superior o inferior
        const middleViewport = window.innerHeight / 2;
        const hostMiddle = hostPos.top + (hostPos.height / 2);
        const isUpperHalf = hostMiddle < middleViewport;
        if (!isUpperHalf) {
            top = hostPos.top - tooltipPos.height; // Mostrar arriba
        }

        this.renderer.setStyle(this.tooltipElement, 'left', `${left}px`);
        this.renderer.setStyle(this.tooltipElement, 'top', `${top}px`);
    }

    destroyTooltip() {
        if (this.tooltipElement) {
            this.renderer.removeChild(this.el.nativeElement, this.tooltipElement);
            this.renderer.removeChild(document.body, this.tooltipElement);
            this.tooltipElement = null;
        }
    }
}